<template>
  <a @click="triggerAction">
    <MIcon name="pencil" class="mr-2" />
    <FlotoDrawerForm
      :open="showForm"
      @submit="handleFormSubmit"
      @cancel="showForm = false"
    >
      <template v-slot:header>
        {{ $t('edit') }} {{ defaultValue.name }} :
        {{ defaultValue.displayName }}
      </template>
      <AssetEditForm
        v-model="formData"
        :movement-type="movementType"
        :reset-form="resetForm"
      />
      <template v-slot:actions="{ hide, submit }">
        <MButton
          id="update-btn"
          :loading="processing"
          class="mr-2"
          @click="submit"
          >{{ $t('update') }}</MButton
        >
        <MButton id="cancel-btn" variant="default" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawerForm>
  </a>
</template>

<script>
import AssetEditForm from './asset-edit-form'
export default {
  name: 'AssetEditDrawer',
  components: { AssetEditForm },
  props: {
    movementType: { type: String, default: undefined },
    defaultValue: {
      type: Object,
      default() {
        return {}
      },
    },
    update: { type: Function, required: true },
  },
  data() {
    return {
      showForm: false,
      processing: false,
      formData: { ...this.defaultValue },
    }
  },
  watch: {
    defaultValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.formData = { ...newValue }
      }
    },
  },
  methods: {
    resetForm(data) {
      this.formData = { ...data }
    },
    triggerAction() {
      this.$emit('trigger')
      setTimeout(() => {
        this.showForm = true
        this.formData = { ...this.defaultValue }
      }, 400)
    },
    handleFormSubmit() {
      this.processing = true
      this.update(this.formData)
        .then(() => {
          this.showForm = false
        })
        .finally(() => (this.processing = false))
    },
  },
}
</script>
